/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';

import * as Sentry from '@sentry/angular';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { IStorageToken } from './app/interfaces/storage-service.interface';
import { StorageService } from './app/services/storage.service';
import { IParserToken } from './app/interfaces/parse-service.interface';
import { ParseService } from './app/services/object-parse.service';
import { ICryptoToken } from './app/interfaces/encryption-service.interface';
import { CryptoService } from './app/services/crypto.service';
import { AuthInterceptor } from './app/interceptos/auth-interceptor';
import { ErrorInterceptor } from './app/interceptos/error.interceptor';
import { SessionDataInterceptor } from './app/interceptors/session-data.interceptor';
import { NgxSpinnerService } from 'ngx-spinner';
import { SpinnerService } from './app/services/spinner.service';
import { provideRouter } from '@angular/router';
import { CreditSimulatorComponent } from './app/modules/simulator/pages/credit-simulator/credit-simulator.component';
import { AppModules } from './app/models/enums/routes.enum';
import { CreditRequestLayoutComponent } from './app/layouts/credit-request-layout/credit-request-layout.component';
import { ERROR_MESSAGE_MAP_TOKEN, ERROR_MESSAGES_MAP } from './app/data/error-messages.map';

Sentry.init({
  dsn: 'https://2718ff365cfd6577f8a7a97bb37593c9@o4507113253371904.ingest.de.sentry.io/4507197603184720',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: IStorageToken, useClass: StorageService },
    { provide: IParserToken, useClass: ParseService },
    { provide: ICryptoToken, useClass: CryptoService },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SessionDataInterceptor, multi: true },
    { provide: NgxSpinnerService, useExisting: SpinnerService },
    { provide: ERROR_MESSAGE_MAP_TOKEN, useValue: ERROR_MESSAGES_MAP },
    provideRouter([
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
      { path: 'home', component: CreditSimulatorComponent },
      { path: 'login', component: CreditSimulatorComponent },
      {
        path: AppModules.CREDIT_REQUEST,
        component: CreditRequestLayoutComponent,
        loadChildren: () =>
          import('./app/modules/credit-request/routes/credit-request.routes').then((m) => m.creditRequestRoutes),
      },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: '**', redirectTo: 'home', pathMatch: 'full' },
    ]),
  ],
})
  // eslint-disable-next-line no-console
  .catch((err) => console.error(err));
